module.exports = __webpack_public_path__ + "static/img/bhcmzzjd_1.8bdb6a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/bhcmzzjd_1.jpg
// module id = EfIB
// module chunks = 15